
namespace Matrix.Indexation {
    export class IndexesColumns {
        static columnsKey = 'Indexation.Indexes';
    }
}